<p class="text-muted my-0 text-{{position}} d-flex">
    <span *ngFor="let star of listVote" class="fa-solid fa-star text-warning me-1"></span>
    <span *ngFor="let star of listDefault" class="fa-regular fa-star me-1"></span>
</p>